module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "hit-form modal-card",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('h2', {
    staticClass: "modal-card-title"
  }, [_c('img', {
    attrs: {
      "src": '/static/img/icon_' + _vm.lower_type + '.svg'
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('hit_form.title_' + _vm.lower_type)) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.$emit('close')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-body"
  }, [(_vm.type != _vm.HIT_TYPES.IMAGE) ? _c('p', {
    staticClass: "hit-form_path control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.path),
      expression: "path"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('hit_form.path_' + _vm.lower_type)
    },
    domProps: {
      "value": (_vm.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.path = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type == _vm.HIT_TYPES.IMAGE) ? _c('p', {
    staticClass: "hit-form_upload"
  }, [_c('uploader', {
    attrs: {
      "url": "upload"
    },
    on: {
      "start": _vm.uploadStart,
      "done": _vm.uploadDone,
      "error": _vm.uploadError
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _vm._m(0)])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading_img),
      expression: "loading_img"
    }],
    staticClass: "help is-info"
  }, [_vm._v(_vm._s(_vm.$t('loading')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading_error),
      expression: "loading_error"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n      " + _vm._s(_vm.$t(_vm.loading_error, {
    max: _vm.loading_error == 'validation.max.file' ? '2Mo' : ''
  })) + "\n    ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.path.$error && !_vm.$v.path.required),
      expression: "$v.path.$error && !$v.path.required"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.required'))
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.path.$error && !_vm.$v.path.maxLength),
      expression: "$v.path.$error && !$v.path.maxLength"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.max.string', {
        max: 190
      }))
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == _vm.HIT_TYPES.VIDEO && _vm.$v.path.$error && !_vm.$v.path.socialVideoUrl),
      expression: "type == HIT_TYPES.VIDEO && $v.path.$error && !$v.path.socialVideoUrl"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.video_url'))
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == _vm.HIT_TYPES.CODE && _vm.$v.path.$error && !_vm.$v.path.codeUrl),
      expression: "type == HIT_TYPES.CODE && $v.path.$error && !$v.path.codeUrl"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.code_url'))
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == _vm.HIT_TYPES.LINK && _vm.$v.path.$error && !_vm.$v.path.matchRegexp),
      expression: "type == HIT_TYPES.LINK && $v.path.$error && !$v.path.matchRegexp"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.active_url'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hit-form_fields"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "input is-large",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('hit_form.field_title')
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.title.$error && !_vm.$v.title.required),
      expression: "$v.title.$error && !$v.title.required"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.required'))
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.title.$error && !_vm.$v.title.maxLength),
      expression: "$v.title.$error && !$v.title.maxLength"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.max.string', {
        max: 70
      }))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": _vm.$t('hit_form.field_description')
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.description.$error && !_vm.$v.description.required),
      expression: "$v.description.$error && !$v.description.required"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.required'))
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.description.$error && !_vm.$v.description.maxLength),
      expression: "$v.description.$error && !$v.description.maxLength"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.max.string', {
        max: 500
      }))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('multiselect', {
    attrs: {
      "max": 5,
      "options": _vm.tags_list,
      "taggable": true,
      "multiple": true,
      "track-by": "id",
      "label": "name",
      "tag-placeholder": _vm.$t('hit_form.no_tag_found'),
      "placeholder": _vm.$t('hit_form.field_tags'),
      "open-direction": "top"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  }, [_c('div', {
    attrs: {
      "slot": "maxElements"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validation.max.array', {
        max: 5
      }))
    },
    slot: "maxElements"
  })])], 1)]), _vm._v(" "), (_vm.type == _vm.HIT_TYPES.IMAGE && _vm.path) ? _c('figure', {
    staticClass: "hit-form_preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.path,
      "alt": _vm.title
    }
  })]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('b-dropdown', {
    model: {
      value: (_vm.is_public),
      callback: function($$v) {
        _vm.is_public = $$v
      },
      expression: "is_public"
    }
  }, [_c('button', {
    staticClass: "button is-flat",
    attrs: {
      "slot": "trigger",
      "type": "button"
    },
    slot: "trigger"
  }, [(_vm.is_public) ? [_c('b-icon', {
    attrs: {
      "icon": "web"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hit_form.public_title')))])] : [_c('b-icon', {
    attrs: {
      "icon": "account-multiple-outline"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hit_form.private_title')))])], _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 2), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('b-icon', {
    staticClass: "media-left",
    attrs: {
      "icon": "web"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('hit_form.public_title')))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$t('hit_form.public_text')))])])], 1)]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": false
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('b-icon', {
    staticClass: "media-left",
    attrs: {
      "icon": "account-multiple-outline"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('hit_form.private_title')))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$t('hit_form.private_text')))])])], 1)])], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('buttons.send')) + "\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('buttons.click_to_upload'))
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558fa6b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalHitForm.vue
// module id = 359
// module chunks = 9